import { render, staticRenderFns } from "./SearchModule.vue?vue&type=template&id=210c63da&scoped=true"
import script from "./SearchModule.vue?vue&type=script&lang=js"
export * from "./SearchModule.vue?vue&type=script&lang=js"
import style0 from "./SearchModule.vue?vue&type=style&index=0&id=210c63da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c63da",
  null
  
)

export default component.exports